<template>
  <modal
    ref="modal"
    variant="default"
    :cta-text="tc('spaSoft.step1.contactPopupCta')"
    aria-labelled-by="spa-contact-popup-title"
    @input="handleOpenModal"
  >
    <template #default="{ activate }">
      <slot v-bind="{ activate }" />
    </template>
    <template #body>
      <div>
        <h6
          id="spa-contact-popup-title"
          class="title"
        >
          {{ tc('spaSoft.step1.contactPopupTitle') }}
        </h6>
        <div class="content-body">
          <p v-html="notificationText" />
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
  import TabTrapMixin from '@mixins/tab-trap'
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'ContactModal',
    mixins: [TabTrapMixin],
    computed: {
      ...mapState('global', ['lang']),
      ...mapGetters('i18n', ['tc']),
      ...mapState('spaSoft', ['propertyData']),
      notificationText() {
        const emailLink = `<a href="mailto:${this.propertyData?.email}">${this.propertyData?.email}</a>`
        const phoneLink = `<a href="tel:${this.propertyData?.phone}">${this.propertyData?.phone}</a>`
        if (!this.propertyData?.phone) {
          return this.tc('spaSoft.step1.contactPopupMessageEmailOnly').replace('[[email]]', emailLink)
        }
        if (!this.propertyData?.email) {
          return this.tc('spaSoft.step1.contactPopupMessagePhoneOnly').replace('[[phone]]', phoneLink)
        }
        return this.tc('spaSoft.step1.contactPopupMessage')
          .replace('[[email]]', emailLink)
          .replace('[[phone]]', phoneLink)
      }
    },
    watch: {
      firstFocusableEl(val) {
        if (val) {
          this.firstFocusableEl.focus()
        }
      },
    },
    methods: {
      handleOpenModal() {
        this.$nextTick(() => {
          this.getFocusableElements()
          this.firstFocusableEl?.focus()
        })
      }
    }
  }
</script>
